import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

interface Props {
  data: { week: string; qty: number }[];
  height?: number;
}

const monthLabel = (iso: string) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export default function WeeklyBarChart({ data, height = 220 }: Props) {
  const formatted = data.map((d) => ({ ...d, label: monthLabel(d.week) }));
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <BarChart data={formatted} margin={{ top: 10, right: 16, left: 0, bottom: 4 }}>
          <CartesianGrid stroke="#e5e7eb" vertical={false} />
          <XAxis
            dataKey="label"
            stroke="#9ca3af"
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke="#9ca3af"
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(15,23,42,0.04)" }}
            contentStyle={{
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              fontSize: 12,
              boxShadow: "0 1px 2px rgba(15,23,42,0.06)",
            }}
            labelFormatter={(_label, payload) => {
              const point = payload?.[0]?.payload as { week?: string } | undefined;
              return point?.week ? `Week of ${point.week}` : "";
            }}
            formatter={(value: number) => [value.toLocaleString(), "Quantity"]}
          />
          <Bar dataKey="qty" fill="#4f46e5" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
